const packageJson = require("../../package.json");
const appVersion = packageJson.version;
const apiVersion = packageJson.apiVersion;

export const environment = {
  production: false,
  isLocal: false,
  name: "DEV",
  auth2FA: false,
  baseAdminUrl: "https://admin.wi.dev.bckpp.com",
  baseApiUrl: "https://api.wi.dev.bckpp.com",
  cdnUrl: "https://inventories.cdn.dev.bckpp.com",
  appVersion,
  apiVersion,
};
